import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["length","scale","data_type"];

  
  // set the length field disabled attribute when editing an existing column definition based on the value of data type
  lengthTargetConnected(target) 
  {
    if (["varchar", "character", "decimal", "timestamp", "timestamptz", "time", "timetz"].includes(this.data_typeTarget.value)) {
      target.disabled = false;
    } else {
      target.disabled = true;
    }
  }

  // set the scale field disabled attribute when editing an existing column definition based on the value of data type
  scaleTargetConnected(target) 
  {
    if (["decimal"].includes(this.data_typeTarget.value)) {
      target.disabled = false;
    } else {
      target.disabled = true;
    }
  }

  // respond to a change to data_type
  toggle(event) {
    const value = event.target.value;
    if (["varchar", "character", "decimal", "timestamp", "timestamptz", "time", "timetz"].includes(value)) {
      this.lengthTarget.disabled = false;
    } else {
      this.lengthTarget.disabled = true;
      this.lengthTarget.value = ""; // Clear the value when disabled
    }
    
    if (["decimal"].includes(value)) {
      this.scaleTarget.disabled = false;
    } else {
      this.scaleTarget.disabled = true;
      this.scaleTarget.value = ""; // Clear the value when disabled
    }
  }
}
